import { render, staticRenderFns } from "./HotUpdateConfigListPage.vue?vue&type=template&id=1b63c828&"
import script from "./HotUpdateConfigListPage.vue?vue&type=script&lang=js&"
export * from "./HotUpdateConfigListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports